import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "modal-dialog modal-xl modal-dialog-scrollable"
}
const _hoisted_4 = {
  key: 1,
  class: "modal-dialog modal-xl modal-dialog-scrollable"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "table table-hover" }
const _hoisted_8 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_9 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_10 = { class: "align-middle" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "input-group-append" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = {
  key: 2,
  class: "modal-dialog modal-xl modal-dialog-scrollable"
}
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modal-header" }
const _hoisted_20 = { class: "modal-title" }
const _hoisted_21 = { class: "modal-body" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "error" }
const _hoisted_25 = { class: "modal-footer" }
const _hoisted_26 = ["disabled"]

import { ref, computed, toRef } from 'vue'

    import { copyToClipboard, isNullOrWhitespace } from '@common/Common'

    import type { PanelistReadModel } from '@Evaluation/Estimations/Domain/readmodels'
    import type { SurveyAccessLinksViewModel } from '@Evaluation/Estimations/Components/SurveyAccessLinks'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyAccessLinks',
  props: {
    viewModel: {}
  },
  emits: ["send-email", "download-links"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened)
    const initialized = computed(() => vm.value.intialized)
    const panelists = computed(() => vm.value.panelists)

    const step = computed<string>({
        get: () => vm.value.step,
        set: val => { vm.value.step = val }
    })

    // ---------------- local state ----------------

    const recipients = ref<PanelistReadModel[] | null>(null)
    const emailSubject = ref<string>('Please complete this survey')
    const emailBody = ref<string>('Please click on the following link to complete your survey: {url}')

    // ---------------- derived ----------------

    const emailBodyError = computed(() =>
        emailBody.value.indexOf('{url}') === -1
            ? '{url} is required in the message.'
            : null
    )

    const canSendEmail = computed(() =>
        isNullOrWhitespace(emailBodyError.value)
    )

    // ---------------- actions ----------------

    function handleSendEmail()
    {
        emit('send-email', {
            SurveyId: vm.value.surveyId,
            EmailSubject: emailSubject.value,
            EmailBody: emailBody.value,
            Recipients: recipients.value
        })
    }

    function handleDownloadLinks()
    {
        emit('download-links', vm.value.surveyId)
    }

    function showLinks()
    {
        step.value = 'links'
        recipients.value = null
    }

    function emailOne(rm: PanelistReadModel)
    {
        recipients.value = [rm]
        step.value = 'email'
    }

    function emailAll()
    {
        recipients.value = panelists.value
        step.value = 'email'
    }

    function copyAccessUrlToClipboard(rm: PanelistReadModel)
    {
        copyToClipboard(rm.AccessUrl)

        const url = rm.AccessUrl
        rm.AccessUrl = 'Copied to clipboard'

        const handle = setTimeout(() =>
        {
            rm.AccessUrl = url
            clearTimeout(handle)
        }, 500)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.intialized)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", { class: "modal-content" }, [
                  _createElementVNode("div", { class: "modal-header" }, [
                    _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, "Access links", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: close
                    }, "×")
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-body" }, [
                    _createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
                    _createTextVNode(" Loading... ")
                  ], -1 /* CACHED */)),
                  _createElementVNode("div", { class: "modal-footer" }, [
                    _createElementVNode("button", {
                      onClick: close,
                      type: "button",
                      class: "btn btn-outline-secondary"
                    }, "Close")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.intialized && step.value === 'links')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", { class: "modal-header" }, [
                    _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "modal-title" }, "Access links", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: close
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                      _createElementVNode("table", _hoisted_7, [
                        _cache[8] || (_cache[8] = _createElementVNode("thead", { class: "thead-light" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Panelist"),
                            _createElementVNode("th", null, "Access link")
                          ])
                        ], -1 /* CACHED */)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panelists.value, (p) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: p.ProjectUserId
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("span", null, _toDisplayString(p.Name), 1 /* TEXT */),
                                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                (p.HasEmail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(p.Email), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                (!p.HasEmail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Email not provided"))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("td", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    readonly: "",
                                    "onUpdate:modelValue": ($event: any) => ((p.AccessUrl) = $event)
                                  }, null, 8 /* PROPS */, _hoisted_12), [
                                    [_vModelText, p.AccessUrl]
                                  ]),
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("button", {
                                      class: "btn btn-outline-secondary",
                                      type: "button",
                                      title: "Copy to clipboard",
                                      onClick: ($event: any) => (copyAccessUrlToClipboard(p))
                                    }, [...(_cache[6] || (_cache[6] = [
                                      _createElementVNode("i", {
                                        class: "fa fa-clipboard",
                                        "aria-hidden": "true"
                                      }, null, -1 /* CACHED */)
                                    ]))], 8 /* PROPS */, _hoisted_14),
                                    _createElementVNode("button", {
                                      class: "btn btn-outline-secondary",
                                      type: "button",
                                      title: "Send link via email",
                                      disabled: !p.HasEmail,
                                      onClick: ($event: any) => (emailOne(p))
                                    }, [...(_cache[7] || (_cache[7] = [
                                      _createElementVNode("i", { class: "fa-regular fa-envelope" }, null, -1 /* CACHED */)
                                    ]))], 8 /* PROPS */, _hoisted_15)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: handleDownloadLinks,
                      class: "btn btn-outline-secondary"
                    }, "Download links"),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _withModifiers(emailAll, ["prevent"]),
                      class: "btn btn-outline-secondary"
                    }, "Email all")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.intialized && step.value === 'email')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("h5", _hoisted_20, "Send email (" + _toDisplayString(recipients.value.length) + ")", 1 /* TEXT */),
                    _createElementVNode("button", {
                      type: "button",
                      class: "close",
                      onClick: close
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("form", {
                      id: "survey-access-links-email-form",
                      onSubmit: _withModifiers(handleSendEmail, ["prevent"])
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", null, "Subject:", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailSubject).value = $event)),
                          required: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            emailSubject.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _withDirectives(_createElementVNode("textarea", {
                          rows: "5",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailBody).value = $event)),
                          required: ""
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            emailBody.value,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(emailBodyError.value), 1 /* TEXT */)
                      ])
                    ], 32 /* NEED_HYDRATION */)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: showLinks,
                      class: "btn btn-outline-secondary"
                    }, "Back"),
                    _createElementVNode("button", {
                      type: "submit",
                      form: "survey-access-links-email-form",
                      disabled: !canSendEmail.value,
                      class: "btn btn-primary"
                    }, "Send email", 8 /* PROPS */, _hoisted_26)
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})